import { Pencil } from "lucide-react";

// Ouvre la modale « Modifier les informations » de la fiche (écoutée par CandidateProfile).
export default function EditInfoButton({ candidateId, testid, className = "" }) {
    const open = () => window.dispatchEvent(new CustomEvent("prerec:open-identity-edit", { detail: { candidate_id: candidateId } }));
    return (
        <button
            type="button"
            onClick={open}
            data-testid={testid}
            className={`inline-flex items-center gap-1 rounded-full bg-white border border-shariti-orange/50 text-shariti-orange hover:bg-shariti-orange hover:text-white px-2.5 py-1 text-[10px] font-black uppercase tracking-wider normal-case transition ${className}`}
        >
            <Pencil className="h-3 w-3" /> Modifier les informations
        </button>
    );
}
